<template>
  <div class="activity-warp">
    <div class="activity-head">
      <img class="backicon" src="../../assets/imgs/close.png" @click="onBack">
      <div class="activity-title">{{i18nDeviceManager.devices_management}}</div>
    </div>
    <div class="list" v-for="(item, i) in items" :key="i">
      <div class="item">
        <div>
          <van-image :src="require('assets/imgs/wifi_pro.png')" ></van-image>
          <div class="item-b" v-if="item.pdefault == 1">{{i18nDeviceManager.default_devive}}</div>
        </div>
        <div class="item-r">
          <div class="device">{{i18nDeviceManager.devices}} {{ i+ 1 }}</div>
          <div class="no">{{item.pSn}}</div>
          <div class="btn-r">
            <van-button @click="deleteDia(item)" class="delete">{{i18nDeviceManager.delete}}</van-button>
            <van-button @click="setDefault(item)" :class="item.pdefault == 1?'disableD':'default'"  :disabled="item.pdefault == 1?true:false">{{i18nDeviceManager.set_as_default}}</van-button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="items.length == 0" style="margin-top: 200px;">
      <van-image :src="require('assets/imgs/device_empt.png')"></van-image>
    </div>
    <div class="bindMore" v-if="items.length == 1">*{{i18nDeviceManager.bind_multiple}}</div>
    <div style="width: 100%;height: 180px"></div>
    <div class="activity-foot">
      <button class="activation-btn" @click="toActivation">{{i18nDeviceManager.add_a_device}}</button>
      <div class="go-home" @click="backHome">
        <img src="../../assets/imgs/go_back_home.png" @click="onBack">
        <label class="content">{{i18nDeviceManager.back_to_home}}</label>
      </div>
    </div>
    <van-dialog
      v-model="deleteDialog"
      show-cancel-button
      :confirmButtonText="$t('confirm.msg_fail_confirm')"
      :cancelButtonText="$t('confirm.msg_fail_cancel')"
      @confirm="deleteDevice"
    >
      <div class="delete-popup">
        {{i18nDeviceManager.do_you_delete}}
      </div>
    </van-dialog>
    <div style="position: fixed;right: 20px;bottom: 15%;">
      <a href="whatsapp://send?phone=+15360129730">
        <img src="../../assets/imgs/contactus/icon_whatsapp.png" alt="" height="40px" width="40px">
      </a>
    </div>
  </div>
</template>

<script>
import { baseURL } from '../../utils/http'
import { MIFI_DEFAULT, MIFI_DELETE, MIFI_DEVICE } from '@/apis/cabinet'
export default {
  computed: {
    i18n () {
      return this.$t('login')
    },
    i18nDeviceManager () {
      return this.$t('deviceManager')
    }
  },
  data () {
    return {
      items: [],
      deleteDialog: false,
      deleteItem: null
    }
  },
  methods: {
    toActivation() {
      this.$router.push("/activityDevice")
    },
    onBack () {
      this.$router.go(-1)
    },
    deviceList() {
      this.$post(
        MIFI_DEVICE, {}, (resp) => {
          this.$loading(false)
          this.items = resp.list;
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    setDefault(item) {
      this.$post(
        MIFI_DEFAULT, { pId: item.pId }, (resp) => {
          this.$loading(false)
          this.deviceList();
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    deleteDia(item) {
      this.deleteItem = item;
      this.deleteDialog = true
    },
    deleteDevice() {
      this.$post(
        MIFI_DELETE, { pId: this.deleteItem.pId }, (resp) => {
          this.$loading(false)
          this.deviceList();
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    backHome() {
      this.$router.push('/')
    }
  },
  created () {
    this.deviceList()
  }
}
</script>

<style lang="less" scoped>
.activity-warp {
  height: 100vh;
  // background: linear-gradient(#00AB46, #1A2229);
  .activity-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;

    .backicon {
      width: 50px;
    }
    .activity-title {
      text-align: center;
      width: 100%;
      font-family: Montserrat, Montserrat;
      font-weight: bold;
      font-size: 36px;
      color: #1A2229;
    }
  }
}
.list{
  padding: 20px 30px;
  background: #ffffff;
  margin: 20px;
  box-shadow: 0px 6px 10px 1px rgba(0,0,0,0.05);
  border-radius: 18px 18px 18px 18px;
  .item{
    display: flex;
  }
  .item-r{
    padding-left: 50px;
    width: 100%;
  }
  .item-b{
    font-family: Work Sans-Bold;
    font-weight: 400;
    font-size: 12px;
    color: #FFFFFF;
    line-height: 0px;
    text-align: center;
    width: 119px;
    height: 31px;
    background: #036EB8;
    border-radius: 0px 18px 0px 18px;
    align-content: center;
    margin-top: -10px;
  }
  .device{
    font-family: Work Sans, Work Sans;
    font-weight: bold;
    font-size: 32px;
    color: #333333;
    padding-bottom: 40px;
  }
  .no{
    font-family: Work Sans, Work Sans;
    font-weight: 400;
    font-size: 28px;
    color: #333333;
  }
  .btn-r{
    text-align: right;
    padding: 40px 0 0 0;
  }
  .delete{
    background: #FFFFFF;
    border-radius: 40px 40px 40px 40px;
    border: 2px solid #036EB8;
    width: 159px;
    height: 60px;
    color: #036EB8;
  }
  .default{
    width: 250px;
    height: 60px;
    background: #FFFFFF;
    border-radius: 40px 40px 40px 40px;
    border: 2px solid #036EB8;
    margin-left: 20px;
    color: #036EB8;
  }
  .disableD{
    width: 250px;
    height: 60px;
    background: #FFFFFF;
    border-radius: 40px 40px 40px 40px;
    border: 2px solid #E1E1E1;
    margin-left: 20px;
    color: #E1E1E1;
  }
}
.bindMore{
  text-align: center;
  font-weight: 400;
  font-size: 22px;
  color: #666666;
  width: 100%;
}
.activity-foot {
  width: 100%;
  margin: 40px auto 0;
  bottom: 0;
  position: fixed;
  left: 0;
  right: 0;
  text-align: center;
  background: #eeebeb;
  .activation-btn{
    font-family: Montserrat, Montserrat;
    font-weight: bold;
    font-size: 40px;
    color: #FFFFFF;
    border: none;
    width: 670px;
    height: 98px;
    background: #036EB8;
    border-radius: 50px 50px 50px 50px;
    margin-top: 49px;
  }
  .go-home{
    text-align: center;
    width: 100%;
    margin: 21px auto;
    img{
      width: 34px;
      height: 34px;
      vertical-align: -5px;
      display: inline-block;
    }
    .content{
      font-family: Montserrat, Montserrat;
      font-weight: 400;
      font-size: 28px;
      color: #036EB8;
      margin-top: -3px;
    }
  }
}
.delete-popup{
  margin: 64px 0 32px;
  padding: 24px 46px;
}
</style>
